import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const addUserEmailDetails = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.ORGANIZATION_SETTINGS.ADD_USER_EMAIL_DETAILS,
    data
  );
};

export default addUserEmailDetails;
